// extracted by mini-css-extract-plugin
export default {"wrapper":"adminTabListItem_wrapper__tCkJ0","title":"adminTabListItem_title__25i-N","activeTab":"adminTabListItem_activeTab__-AiWR"};